import React, {FC, Suspense, lazy, useMemo, useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch, useLocation} from 'react-router-dom';

import Loader from './components/Common/Loader';

import './assets/scss/fonts.scss';
import './assets/scss/globals.scss';

const MatchcenterPage = lazy(
  () => import(/* webpackChunkName: "matchcenter" */ './views/MatchcenterPage')
);
const MatchPage = lazy(() => import(/* webpackChunkName: "match" */ './views/MatchPage'));

// TODO: update match page path

const MatchcenterApp: FC = () => (
  <>
    <Suspense fallback={<Loader fullpage />}>
      <Switch>
        <Route path="/:matchSlug/:matchId" component={MatchPage} />
        <Route path="/:filter" component={MatchcenterPage} />
        <Route path="/" component={MatchcenterPage} />
      </Switch>
    </Suspense>
  </>
);;

export default MatchcenterApp;
